module.exports = __webpack_public_path__ + "static/media/sahab.95b33c44.png";